module.exports = __webpack_public_path__ + "img/districomoil.8ef5be16.jpg";